import plan from './plan';
import minisite from './minisite';
import code from './code';
import product from './product';
import business from './business';
import announce from './announce';
import procurement from './procurement';
import messenger from './messenger';
import subdirectory from './subdirectory';

export default [
  ...plan,
  ...minisite,
  ...code,
  ...product,
  ...business,
  ...announce,
  ...procurement,
  ...messenger,
  ...subdirectory,
];
